var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacilitiesOnlyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.73 141.73",
    style: {
      enableBackground: "new 0 0 141.73 141.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Facilities_only_-_Blue"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#10385A",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 102.199,
    y1: 70.89,
    x2: 92.794,
    y2: 56.572
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10385A",
      stroke: "#10385A",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M102.131,71.211l-16.229,0.06 c-1.27,0-2.299-1.029-2.299-2.299V58.77c0-1.27,1.029-2.299,2.299-2.299h16.943c0.85,0,1.406-0.891,1.032-1.655l-3.525-7.194 c-0.386-0.788-1.187-1.287-2.064-1.287H39.95c-2.539,0-4.597,2.058-4.597,4.597v33.582c0,2.539,2.058,4.597,4.597,4.597h5.945 h12.57h23.876l12.434,0.101h7.005c2.539,0,4.597-2.058,4.597-4.597v-6.676c0-0.448-0.131-0.887-0.377-1.262l-3.591-5.467 L102.131,71.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#10385A",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M45.895,61.068v6.01 c0,2.539,2.058,4.597,4.597,4.597h17.972c2.539,0,4.597-2.058,4.597-4.597v-6.01c0-2.539-2.058-4.597-4.597-4.597H50.492 C47.953,56.471,45.895,58.529,45.895,61.068z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#10385A",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 52.18,
    cy: 89.111,
    r: 6.285
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#10385A",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 88.625,
    cy: 89.111,
    r: 6.285
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10385A"
    },
    d: "M98.323,38.188l20.897-20.897c1.644-1.644,4.46-0.694,4.772,1.61l3.287,24.244 c0.25,1.843-1.328,3.417-3.17,3.162L99.925,42.96C97.625,42.641,96.681,39.83,98.323,38.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#10385A",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M127.558,70.826 c0.01,14.522-5.525,29.047-16.605,40.126c-22.14,22.14-58.036,22.14-80.176,0s-22.14-58.036,0-80.176s58.036-22.14,80.176,0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilitiesOnlyBlue);
export default __webpack_public_path__ + "static/media/Facilities Only - Blue.7bbd5d2e7942bf6ab21fde890f201aba.svg";
export { ForwardRef as ReactComponent };